import isValidSellAmount from "./../validations/is.valid.sell.amount";

export default (values, value, type) => isValidSellAmount(value);
